module.exports = __webpack_public_path__ + "media/images/icon_area01_23-23-9dfaf31c54e369bf37bc99856836d4aa.png";